/**
 * Creates a valid custom element name that is versioned (major)
 */
function getElementTag(name, version) {
  const formattedVersion = version ? `-v${version.split('.')[0]}` : ''
  return name + formattedVersion
}

module.exports.getElementTag = getElementTag
